// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1RGR4","rightAdornment":"Header_rightAdornment__1AXgA"};